import React from "react";
import PredictionDataExcelExport from "./PredictionDataExcelExport";
import UserDataExcelExport from "./UserDataExcelExport";

export default function ExportsModule() {
  return (
    <div className="grid gap-12">
      <PredictionDataExcelExport />
      <UserDataExcelExport />
    </div>
  );
}
